import React from "react";
import styled from "styled-components";
import TimeField from "react-simple-timefield";
import { ChevronUp, ChevronDown } from "styled-icons/boxicons-regular";
import InputNumber from "rc-input-number";
import "rc-input-number/assets/index.css";
export { ReactSimpleRadioButton } from "./radioButton";

export const InputNum = ({
  label,
  name,
  value,
  editMode,
  handleChange,
  color,
  min,
  max,
  style,
  per
}) => (
    <div className={per && "percentage"}>
      <label>{label}</label>
      {editMode ? (
        <div className={per && "percentageInput"}>
          <input
            type="number"
            name={name}
            style={style}
            value={value}
            onChange={handleChange}
            min={min}
            max={max}
          /> {per && "%"} </div>
      ) : (
          <div>{value}</div>
        )}
    </div>
  );

export const InputTime = ({
  label,
  name,
  value,
  editMode,
  handleChange,
  style,
}) => {
  return (
    <>
      {label && <label>{label}</label>}
      {editMode ? (
        <TimeField
          input={<input type="text" inputMode="numeric" />}
          value={value}
          name={name}
          style={style}
          onChange={(value) => {
            handleChange({ target: { value, name } });
          }}
          colon={null}
          className={"inputFieldTime"}
        />
      ) : (
          <>{value}</>
        )}
    </>
  );
};
export const InputText = ({
  label,
  name,
  value,
  editMode,
  handleChange,
  color,
  placeholder,
}) => (
    <div>
      <label>{label}</label>
      {editMode ? (
        <input
          type="text"
          name={name}
          style={color ? TimefieldNoColor : TextField}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
        />
      ) : (
          <div>{value}</div>
        )}
    </div>
  );
export const TextArea = ({
  label,
  name,
  value,
  editMode,
  handleChange,
  placeholder,
}) => (
    <div>
      <label>{label}</label>
      {editMode ? (
        <textarea
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          style={TextAreaStyle}
          value={value}
        />
      ) : (
          <div>{value}</div>
        )}
    </div>
  );
export const Text = ({
  label,
  name,
  value,
  editMode,
  handleChange,
  placeholder,
}) => (
    <div>
      <label>{label}</label>
      {editMode ? (
        <input
          type="text"
          name={name}
          placeholder={placeholder}
          style={TextFieldBlock}
          value={value}
          onChange={handleChange}
        />
      ) : (
          <div>{value}</div>
        )}
    </div>
  );
export const HoursAndMinuts = ({ label, name, value, handleChange }) => (
  <HrsMinsCont>
    <label>{label}</label>
    <HrAndMins
      pattern="\d*"
      value={value[0]}
      name={name}
      upHandler={<Chevronup size="20" />}
      downHandler={<ChevronDown size="20" />}
      formatter={(value) => (value.length === 1 ? `0${value}` : `${value}`)}
      parser={(value) => Number(value)}
      maxLength="2"
      onChange={(value) => handleChange(value, name, "hrs")}
      type="number"
    />
    <Collon> :</Collon>
    <HrAndMins
      value={value[1]}
      name={name}
      downHandler={<ChevronDown size="20" />}
      upHandler={<Chevronup size="20" />}
      maxLength="2"
      formatter={(value) => (value.length === 1 ? `0${value}` : `${value}`)}
      parser={(value) => Number(value)}
      onChange={(value) => handleChange(value, name, "mins")}
      step={15}
      pattern="\d*"
      type="number"
    />
  </HrsMinsCont>
);
export const HoursAndMinutsDiv = ({ label, name, value, handleChange }) => (
  <HrsMinsCont>
    <label>{label}</label>
    <HrAndMins
      pattern="[0-9]*"
      value={value[0]}
      name={name}
      upHandler={"   "}
      downHandler={"  "}
      formatter={(value) => (value.length === 1 ? `0${value}` : `${value}`)}
      parser={(value) => Number(value)}
      maxLength="2"
      onChange={(value) => handleChange(value, name, "hrs")}
      disabled={true}
    />
    <Collon> :</Collon>
    <HrAndMins
      value={value[1]}
      name={name}
      upHandler={"   "}
      downHandler={"  "}
      maxLength="2"
      formatter={(value) => (value.length === 1 ? `0${value}` : `${value}`)}
      parser={(value) => Number(value)}
      onChange={(value) => handleChange(value, name, "mins")}
      disabled={true}
    />
  </HrsMinsCont>
);
export const InputNumbers = ({
  label,
  name,
  value,
  editMode,
  handleChange,
}) => (
    <div>
      <label>{label}</label>
      {editMode ? (
        <input
          type="text"
          name={name}
          style={TextField}
          value={value}
          onChange={handleChange}
        />
      ) : (
          <div>{value}</div>
        )}
    </div>
  );
export const Inputnumbers = ({
  label,
  name,
  value,
  handleChange,
  step,
  editMode,
  branchId,
}) => (
    <>
      <label>{label}</label>
      {editMode ? (
        <div>{value} </div>
      ) : (
          <Inputnumber
            pattern="[0-9]*"
            value={value}
            name={name}
            upHandler={<Chevronup size="15" />}
            downHandler={<ChevronDown size="15" />}
            maxLength="2"
            step={["0122" , "0515" , "0675" , "0635"].includes(branchId) ? step : 15}
            onChange={(value) => {
              let event = {};
              event.target = {};
              event.target.value = value;
              event.target.name = name;
              handleChange(event);
            }}
          />
        )}
    </>
  );
const Inputnumber = styled(InputNumber)` position: relative;
bottom: 5px;
height: 44px;
width: 195px;
background: #f1f4f9;
border : none !important
border-bottom: 1px solid #D9D9D9 !important;
border-radius: 0px !important;
.rc-input-number-input {
  font-size: 14px;
  font-family: Trebuchet MS;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
	  -webkit-appearance: none !important;
	  -moz-appearance: none !important;
	  appearance: none !important;
	  margin: 0;
  }
 
}
.rc-input-number-input-wrap {
  .rc-input-number-input {
	background: #f1f4f9 !important;
  }
}
.rc-input-number-handler-wrap {
  border-left: none !important;
}
.rc-input-number-handler-up {
  border: none !important;
  height: 20px;
  bottom: 2px;
  position: relative;
  right: 4px;
  background-color: transparent;
}
.rc-input-number-handler-down {
  position: relative;
  background-color: transparent;
bottom:7px
  height: 16px;
  right: 4px;
  border: none !important;
}

}`;
const HrsMinsCont = styled.div`
  text-align: left;
  label {
    display: block;
    font-size: 14px;
    font-family: Trebuchet MS;
    color: #4a4a4a;
    margin-bottom: 0;
  }
`;
const HrAndMins = styled(InputNumber)` && {
  position: relative;
  bottom: 5px;
  height: 44px;
  width: 62px;
  background: #f1f4f9;
  border: 1px solid #babec3;
  border-radius: 0px !important;
  .rc-input-number-input {
    font-size: 14px;
    font-family: Trebuchet MS;
    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
        margin: 0;
    }
  }
  .rc-input-number-input-wrap {
    .rc-input-number-input {
      background: #f1f4f9 !important;
    }
  }
  .rc-input-number-handler-wrap {
    border-left: none !important;
  }
  .rc-input-number-handler-up {
    border: none !important;
    height: 20px;
    bottom: 2px;
    position: relative;
    right: 4px;
    background-color: transparent;
  }
  .rc-input-number-handler-down {
    position: relative;
    background-color: transparent;
    top:3px
    height: 16px;
    right: 4px;
    border: none !important;
  }
}`;

const Collon = styled.span`
  font-size: 29px;
  position: relative;
  right: 4px;
  top: 5px;
`;
const Chevronup = styled(ChevronUp)`
  background: transparent;
`;
const TimefieldNoColor = {
  width: "100%",
  position: "relative",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  background: "none",
  height: "30px",
  overflowY: "scroll",
  bottom: "14px",
};
const TextField = {
  width: "100%",
  position: "relative",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  padding: "0px,0px,0px,0px",
  height: "30px",
  overflowY: "scroll",
};
const TextFieldBlock = {
  width: "56%",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  padding: "0px,0px,0px,0px",
  height: "16px",
  marginBottom: "15px",
};

const TextAreaStyle = {
  width: "80%",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  padding: "0px,0px,0px,0px",
  position: "relative",
  bottom: "10px",
};
